import { TEntity } from '@operations/app/models'
import { makeObservable, observable, runInAction } from 'mobx'

export class BaseEntityStore<T extends TEntity> {
  items: T[] = []

  constructor() {
    makeObservable(this, {
      items: observable,
    })
  }

  updateAndReplaceItems(items: T[]) {
    const itemsMap = new Map(items.map(item => [item.id, item]))

    runInAction(() => {
      this.items = this.items.map(item => {
        const newItem = itemsMap.get(item.id)
        return newItem ? newItem : item
      })
    })
  }

  updateStoreItems(items: T[]) {
    runInAction(() => {
      this.items = items ?? []
    })
  }

  updateStoreItem(item: T, id: number) {
    const existingItems = this.items.find(i => i.id === id)
    runInAction(() => {
      if (existingItems) this.items = this.items.map(i => (i.id === id ? item : i))
      else {
        this.items.push(item)
        this.items = [...this.items] //This is necessary, otherwise mobx does not update the items array correctly when updateStoreItem & deleteStoreItem(s) called in same time
      }
    })
  }

  deleteStoreItem(id: number) {
    runInAction(() => {
      this.items = this.items.filter(i => i.id !== id)
    })
  }

  deleteStoreItems(ids?: number[]) {
    if (!ids) return
    runInAction(() => {
      this.items = this.items.filter(i => !ids.includes(+i.id))
    })
  }
}
